// src/components/MultiPrintLabelsPage.tsx
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PrintLabelItem } from "../types/PrintLabelItem";

import JsBarcode from "jsbarcode";

const BarcodeLabel: React.FC<{
  fnsku: string;
  itemName: string;
  index: number;
  total: number;
}> = ({ fnsku, itemName, index, total }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      JsBarcode(canvasRef.current, fnsku, {
        format: "CODE128",
        displayValue: true,
        fontSize: 16,
        fontOptions: "bold",
        width: 2,
        height: 70,
        margin: 0,
      });
    }
  }, [fnsku]);

  return (
    <div
      style={{
        width: "50mm",
        height: "30mm",
        padding: "2mm",
        margin: "0 auto",
        pageBreakAfter: "always",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        boxSizing: "border-box",
      }}
    >
      <canvas ref={canvasRef} style={{ width: "100%", marginBottom: "1px" }} />
      <div
        style={{
          fontSize: "11px",
          fontWeight: 800,
          textAlign: "center",
          lineHeight: "1.2",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
          width: "100%",
          marginTop: "2.5px",
          fontFamily: '"Arial Black", "BIZ UD Gothic", "Meiryo", sans-serif',
        }}
      >
        {itemName}
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "2mm",
          right: "2mm",
          fontSize: "10px",
        }}
      >
        {`${index + 1}`}
      </div>
    </div>
  );
};

const MultiPrintLabelsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [labels, setLabels] = useState<PrintLabelItem[]>([]);

  useEffect(() => {
    const key = searchParams.get("key");
    if (!key) return;

    const data = localStorage.getItem(key);
    if (data) {
      try {
        const parsed: PrintLabelItem[] = JSON.parse(data);
        setLabels(parsed);
        localStorage.removeItem(key); // 読み終えたら削除（不要であれば残してもOK）
        console.log("ラベルデータ取得成功:", parsed);
      } catch (e) {
        console.error("ラベルデータの解析に失敗", e);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    if (labels.length > 0) {
      setTimeout(() => {
        window.print();
      }, 500);

      window.onafterprint = () => {
        if (window.opener) window.opener.focus();
        window.close();
      };
    }
  }, [labels]);

  return (
    <div
      style={{
        width: "100%",
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {labels.flatMap((label, idx) =>
        Array.from({ length: label.count }).map((_, i) => (
          <BarcodeLabel
            key={`${idx}-${i}`}
            fnsku={label.fnsku}
            itemName={label.itemName}
            index={i}
            total={label.count}
          />
        ))
      )}
      <style>{`
        @page {
          size: 50mm 30mm;
          margin: 0;
        }

        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            margin: 0;
          }
        }
      `}</style>
    </div>
  );
};
export default MultiPrintLabelsPage;
